/* eslint-disable @typescript-eslint/no-explicit-any */
import httpManager, { ResponseError } from "@/app/shared/utils/httpManager";
import { getPaginationQuery } from "@/app/shared/utils/helpers";
import { IFilters, ISlots } from "@/@types/settings/slots";

class SlotManager {
  private resource = "/billing/slots/";

  async getInfoSlots(): Promise<ISlots> {
    const response = await httpManager.get("/billing/resume/");
    return response.data;
  }

  async buySlots(price: number, count: number): Promise<object> {
    const data = { price, amount: count };
    const response = await httpManager.post(this.resource, data);
    return response.data;
  }

  async deleteSlots(id: number): Promise<object> {
    const response = await httpManager.delete(`${this.resource}${id}`);
    return response;
  }

  async getListSlots({
    filters,
    page = 1,
  }: {
    filters?: IFilters;
    page?: number;
    type?: number;
  } = {}): Promise<any> {
    try {
      const paginationQuery = getPaginationQuery(page, 20);
      console.log(filters);
      const fullname = filters?.search || "";
      const userstatus = filters?.status || "";
      const currentYear = filters?.currentYear || null;
      const currentMonth = filters?.currentMonth || null;
      const query = `?${paginationQuery}&fullname=${fullname}&user_status=${userstatus}&year=${currentYear}&month=${currentMonth}`;
      console.log(query, "QUERYYY");
      const response = await httpManager.get(`${this.resource}${query}`);
      console.log(response, "LISTA DE TABLA");
      return response.data;
    } catch (error: any) {
      throw new ResponseError(error.response);
    }
  }

  async sendEmailRequest(body: {
    first_name: string;
    last_name: string;
    email: string;
    phone_number: string;
    description: string;
  }) {
    await httpManager.post(`${this.resource}send-contact/`, body);
  }
}

export default SlotManager;
